export default __webpack_public_path__ + "static/main-right-e12227200fb9a5c910c3a88bf2d17c09.jpeg";